export const config = {
    host: 'https://proxy.omnistar.io',
    dexAddress: "AE3eeU5mqQUt5KfYhLnGX67LiHKtRcjXV9yoeuYnAgTR"
}
